import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SignatureSimpleResponse } from '../main/pages/services/microservices/response/signatureSimple.response';

/**
 * References:
 * https://www.scholarhat.com/tutorial/angular/sharing-data-between-angular-components-methods
 * https://stackoverflow.com/questions/51660156/share-data-between-components-with-subject
 * https://sumanthmj7298.medium.com/ways-to-share-data-between-angular-components-bf59732a4911
 * https://angular.dev/guide/pipes/unwrapping-data-observables
 */
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private signature = new BehaviorSubject<SignatureSimpleResponse>({
    id: 0,
    dueDate: '',
    taxIdType: { id: 0, description: '' },
    isDateExpired: true,
  });
  private taxpayerId = new BehaviorSubject<number>(0);
  private totalActivities = new BehaviorSubject<number>(0);

  public signature$ = this.signature.asObservable();
  public taxpayerId$ = this.taxpayerId.asObservable();
  public totalActivities$ = this.totalActivities.asObservable();

  setSignature(signature: SignatureSimpleResponse) {
    this.signature.next(signature);
  }

  setTaxpayerId(id: number) {
    this.taxpayerId.next(id);
  }

  setTotalActivities(total: number) {
    this.totalActivities.next(total);
  }
}
